<template>
  <section v-if="$store.state.auth.success" class="section small container">
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li :class="{ 'is-active': $route.path === '/domains' }">
          <router-link to="/domains">Start</router-link>
        </li>

        <li v-if="$route.path === '/profile'" class="is-active">
          <a>Profile</a>
        </li>

        <li v-if="$route.path === '/api-documentation'" class="is-active">
          <a>API documentation</a>
        </li>

        <li
          v-if="domain"
          :class="{ 'is-active': $route.path === `/domains/${domain.uid}` }"
        >
          <router-link :to="`/domains/${domain.uid}`">
            <span class="icon">
              <i class="mdi mdi-domain"></i>
            </span>
            <span>{{ domain.friendlyName }}</span>

            <span
              v-if="domain.shared"
              class="margin-left-5"
              data-tooltip="Shared with me"
            >
              <i class="mdi mdi-share-variant"></i>
            </span>
          </router-link>
        </li>

        <li
          v-if="computer && domain"
          :class="{
            'is-active':
              $route.path ===
              `/domains/${domain.uid}/computers/${computer.uid}/packages`,
          }"
        >
          <router-link
            :to="`/domains/${domain.uid}/computers/${computer.uid}/packages`"
          >
            <span class="icon" :class="{ 'has-text-success': computer.online }">
              <i class="mdi mdi-laptop"></i>
            </span>
            <span>{{ computerName(computer) }}</span>
          </router-link>

          <span
            v-if="computer.inventorying"
            data-tooltip="Inventorying"
            class="margin-right-10"
          >
            <span class="spinner small mg"></span>
          </span>
        </li>

        <li
          v-if="
            (computer &&
              domain &&
              $route.path ===
                `/domains/${domain.uid}/computers/${computer.uid}/applications`) ||
              (domain && $route.path === `/domains/${domain.uid}/applications`)
          "
          class="is-active"
        >
          <a>
            <span class="icon">
              <i class="mdi mdi-format-list-checks"></i>
            </span>
            <span>Applications</span>
          </a>
        </li>

        <li
          v-if="groupInfo && domain"
          :class="{
            'is-active':
              $route.path ===
              `/domains/${domain.uid}/groups/${groupInfo.group.uid}/packages`,
          }"
        >
          <router-link
            :to="
              `/domains/${domain.uid}/groups/${groupInfo.group.uid}/packages`
            "
          >
            <span class="icon">
              <i class="mdi mdi-monitor-multiple"></i>
            </span>
            <span>{{ groupInfo.group.name }}</span>
          </router-link>
        </li>

        <li
          v-if="domain && $route.path === `/domains/${domain.uid}/shares`"
          class="is-active"
        >
          <a>
            <span class="icon">
              <i class="mdi mdi-account-multiple-plus"></i>
            </span>
            <span>Shares</span>
          </a>
        </li>

        <li v-if="$route.path === `/settings`" class="is-active">
          <a>
            <span class="icon">
              <i class="mdi mdi-cog"></i>
            </span>
            <span>Global settings</span>
          </a>
        </li>

        <li
          v-if="source && $route.path === `/repos/${source.uid}`"
          class="is-active"
        >
          <a>
            <span class="icon">
              <i class="mdi mdi-database"></i>
            </span>
            <span>{{ source.name }}</span>

            <span
              v-if="source && !source.external && source.version >= 2"
              class="margin-left-5"
            >
              <i class="mdi mdi-alpha-h-circle-outline"></i>
            </span>

            <span
              v-if="source && source.shared"
              class="margin-left-5"
              data-tooltip="Shared with me"
            >
              <i class="mdi mdi-share-variant"></i>
            </span>
          </a>
        </li>
      </ul>
    </nav>
  </section>
</template>
<style lang="css" scoped>
.mg {
  margin-bottom: 4px;
}
</style>

<script>
import computerHelpers from "@/utils/computer";

export default {
  computed: {
    domain() {
      return this.$store.getters["domain/single"](this.$route.params.domainUID);
    },
    source() {
      return this.$store.getters["source/single"](this.$route.params.repoUID);
    },
    computer() {
      if (this.$route.params.domainUID) {
        this.$store.dispatch("computer/fetch", {
          domainUID: this.$route.params.domainUID,
        });
      }

      return this.$store.getters["computer/singleComputer"](
        this.$route.params.computerUID
      );
    },
    groupInfo() {
      return this.$store.getters["group/single"](this.$route.params.groupUID);
    },
    computerName() {
      return (computer) => {
        return computerHelpers.getName(computer);
      };
    },
  },

  async mounted() {
    await this.$store.dispatch("domain/fetch");
  },
};
</script>
